import { toaster } from "@/components/ui/toaster";
import { AppRoutes } from "@/constants/routes";
import {
  CreateProductionZoneBody,
  createProductionZone,
} from "@/services/production-zones.service";
import { getAxiosErrorMessage } from "@/utils/axios-error-message";
import { handlePermissionError } from "@/utils/permission-check";
import { NavigateFunction } from "react-router-dom";
import { ProductionZoneCreationForm } from "./production-zone-creation.schema";

interface CreateProductionZoneHandlerProps {
  values: ProductionZoneCreationForm;
  setLoadingCreate: (loading: boolean) => void;
  navigate: NavigateFunction;
  fetchPermissions: () => Promise<void>;
}

export const createProductionZoneHandler = async ({
  values,
  setLoadingCreate,
  navigate,
  fetchPermissions,
}: CreateProductionZoneHandlerProps) => {
  const body: CreateProductionZoneBody = {
    nombre: String(values?.nombre ?? "").trim(),
    zonaComercial: String(
      Array.isArray(values?.zonaComercial)
        ? values?.zonaComercial?.[0] ?? ""
        : values?.zonaComercial ?? "",
    ).trim(),
  };

  setLoadingCreate(true);
  try {
    await createProductionZone(body);

    toaster.create({
      type: "success",
      title: "Zona productiva agregada exitosamente",
    });

    navigate(AppRoutes.PRODUCTION_ZONES);
  } catch (error) {
    const handled = await handlePermissionError(
      error,
      navigate,
      fetchPermissions,
      AppRoutes.PRODUCTION_ZONES,
    );

    if (!handled) {
      toaster.create({
        type: "error",
        title: getAxiosErrorMessage(error, "No se pudo crear la zona productiva."),
      });
    }

    throw error;
  } finally {
    setLoadingCreate(false);
  }
};
